import React,{useState} from 'react';
import EmployAside from '../../aside';
import Info from './info';

const InfoProjet = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <Info setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default InfoProjet;